import { bookingInquiryApis, BookingInquiryQuery } from '@apis/dashboard/bookingInquiryApis';
import { createUseQuery } from '@hooks/createUseQuery';

export const useBookingInquirySearchList = createUseQuery(
  (query: BookingInquiryQuery) => ['/dashboard/booking-inquiry/', query],
  (query) => () =>
    bookingInquiryApis
      .get('/dashboard/booking-inquiry/', {
        query,
      })
      .then((r) => r[200]!),
);
